exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2uZ_YPLU1tI5QYSmbME3Y4{max-width:640px;margin:30px auto}\n", ""]);

// Exports
exports.locals = {
	"OrganizationsSearch": "_2uZ_YPLU1tI5QYSmbME3Y4"
};